import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import moment from "moment-mini";

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private data = new BehaviorSubject('');
  currentData = this.data.asObservable();

  private path = `${environment.baseUrl}`;
  private homePageContent: any = null;

  constructor(private http: HttpClient) {
    //console.log('PSS Info', this.companyMarkets)
    this.setHomepageContent();
  }

  get userMarket() {
    if (localStorage.getItem('market')) {
      return localStorage.getItem('market');
    }
    return localStorage.getItem('defaultMarket')['country'];
  }

  get userCountryName() {
    if (localStorage.getItem('marketParams')) {
      let info = JSON.parse(localStorage.getItem('marketParams')) 
      return info.countryName;
    }
    return localStorage.getItem('defaultMarket')['countryName'];
  }

  get userCurrency() {
    if (localStorage.getItem('marketParams')) {
      let info = JSON.parse(localStorage.getItem('marketParams')) 
      return info.currency;
    }
    return localStorage.getItem('defaultMarket')['currency'];
  }

  get userCurrencySymbol() {
    if (localStorage.getItem('marketParams')) {
      let info = JSON.parse(localStorage.getItem('marketParams')) 
      return info.currencySymbol;
    }
    return localStorage.getItem('defaultMarket')['currencySymbol'];
  }

  get companyConfig() {
    let info = JSON.parse(localStorage.getItem('companyConfig')) 
    return info;
  }

  get googleMapsKey() {
    let info = this.companyConfig
    return info.company.keys.integrations.googleMapsKey
  }

  get companyMarkets() {
    let info = JSON.parse(localStorage.getItem('companyMarkets')) 
    return info;
  }

  get homePageData() {
    if(!this.homePageContent) this.setHomepageContent();
    return this.homePageContent;
  }

  get isMobile() {
    let mobile = false;
    if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      mobile = true;
    }
    return mobile;
  }

  hideLoader() {
    //Hide loader when page is ready
    const loader = document.getElementById('global-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }

  isVisible(componentName:string) {
    let info = JSON.parse(localStorage.getItem('companyConfig')) 
    //console.log(info.visible_components.find(x => x.component_name === componentName).visible)
    return info.visible_components.find(x => x.component_name === componentName).visible;
  }

  setHomepageContent() {
    const infoStr = localStorage.getItem('homePageContent');
    if (infoStr) {
      this.homePageContent = JSON.parse(infoStr);
    } 
    else {
      // fetch from API asynchronously and cache
      this.getHomePageContent().subscribe((res: any) => {
        const data = res.data || res;
        localStorage.setItem('homePageContent', JSON.stringify(data));
        this.homePageContent = data;
      });
    }
  }

  getContent(sectionName: string) {
    if (!this.homePageContent) return undefined; // API not loaded yet
    return this.homePageContent.sections.find(x => x.name === sectionName)?.content[0];
  }

  // getContent(sectionName:string) {
  //   let info = JSON.parse(localStorage.getItem('homePageContent')) 
  //   //console.log(info.visible_components.find(x => x.component_name === componentName).visible)
  //   return info.sections.find(x => x.name === sectionName)?.content[0];
  // }

  getItemfromMarket(itemName:string) {
    let info = this.companyMarkets; 
    //console.log(info.visible_components.find(x => x.component_name === componentName).visible)
    return info.find(x => x.country === this.userMarket)[itemName];
  }

  calculateAge(dob:Date){
    const age = new Date().getFullYear() - dob.getFullYear();
    return age;
  }

  isEligibleForPSS(date:any){
    let dateDifference:any = moment(new Date()).add(7, 'days');
    const marketInfo = this.companyMarkets.find(x => x.country === this.userMarket)
    const hasPaySmallSmall = marketInfo.enabled_payment_methods?.some(
      (item:any) => item.name?.toLowerCase() === 'pay small small'
    );
    //return this.userMarket == 'gh' ? false : moment(date).isAfter(dateDifference)
    return hasPaySmallSmall && moment(date).isAfter(dateDifference)
  }

  passData(status: any) {
    this.data.next(status)
  }

  public getSignature(): Observable<any> {
    return this.http.get(`${this.path}/auth/signature`, {responseType: 'text'});
  }

  public sendContactFormInfo(body): Observable<any> {
    return this.http.post<any>(`${this.path}/contact/email/send`,body);
  }

  public getCompanyConfig(): Observable<any> {
    return this.http.get(`${this.path}/company/config`);
  }

  public getHomePageContent(): Observable<any> {
    return this.http.get<any>(`${this.path}/page/home_page/en-${this.userMarket ?? 'ng'}`);
  }

  public getAboutPageContent(): Observable<any> {
    return this.http.get<any>(`${this.path}/page/about_us/en-${this.userMarket}`);
  }

  getTimeZoneId(lat: number, lng: number): Observable<string> {
    const timestamp = Math.floor(Date.now() / 1000);

    const baseUrl = 'https://maps.googleapis.com/maps/api/timezone/json';

    const url = `${baseUrl}?location=${lat},${lng}` + `&timestamp=${timestamp}` + `&key=${this.googleMapsKey}`;

    return this.http.get<any>(url).pipe(
      map(response => {
        if (response.status !== 'OK') {
          throw new Error(response.errorMessage || 'Failed to get timezone');
        }
        return response.timeZoneId;
      })
    );
  }
}
